/* eslint-disable no-param-reassign */
import { BarSeriesOption, util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import type { PresetMode } from '../..';

function getDefaultProgressBarSeries(
  chart: Parameters<ThemeParser>[1],
  themeMode: PresetMode
): BarSeriesOption {
  /** 获取图标容器的宽高 */
  const { width: DOMWidth } = chart.getDom().getBoundingClientRect();
  /** 进度条中柱子标签距离柱子背景的距离 */
  const labelDistance = 16;
  return {
    // @ts-ignore
    dvType: 'progress',
    barMaxWidth: 18,
    barMinWidth: 18,
    showBackground: true,
    backgroundStyle: {
      color: themeMode === 'light' ? '#f2f2f2' : '#292929'
    },
    label: {
      show: true,
      color: themeMode === 'light' ? '#000' : '#fff',
      verticalAlign: 'middle',
      fontSize: 14,
      lineHeight: 18,
      fontWeight: 510,
      fontFamily: 'sans-serif',
      overflow: 'truncate'
    },
    labelLayout: {
      x: DOMWidth - labelDistance,
      align: 'right',
      // 为进度条右侧的文字标签设置最大宽度，超出宽度则做文本缺省处理
      width: 68
    }
  };
}

function parseBarSeries(
  option: Parameters<ThemeParser>[0],
  seriesOptions: Parameters<ThemeParser>[0]['series'],
  chart: Parameters<ThemeParser>[1],
  themeMode: PresetMode
) {
  (seriesOptions as []).forEach((series, index) => {
    // @ts-ignore
    if (series.type !== 'bar' || series.dvType !== 'progress') {
      return;
    }
    const defaultOption = getDefaultProgressBarSeries(chart, themeMode);

    seriesOptions[index] = util.merge(defaultOption, series, true);
  });
}
/**
 * 专门给海外主题的进度条柱状图的默认配置
 * @param args
 */
export function progressBarThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  option.series = normalizeToArray(option.series);
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  parseBarSeries(option, option.series, chart, themeMode);
}
